import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Basket from '../../Assetes/Images/kfc-main-basket.svg'
import BucketCartItems from './BucketCartItems'
import { useSelector } from 'react-redux';
import { priceunit } from '../../Components/client-config';
import { useTranslation } from 'react-i18next';

export default function BucketCart() {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const { t } = useTranslation();

    const [isSticky, setIsSticky] = useState(true)
    useEffect(() => {
        let storeSelected: any = sessionStorage.getItem("storeSelected");
        let store_id = storeSelected ? JSON.parse(storeSelected).store_id : null;
        window.onscroll = function (ev) {
            if ((window.innerHeight + window.scrollY + 350) >= document.body.offsetHeight) {
                setIsSticky(false)
            } else {
                setIsSticky(true)
            }
        };
    }, [])
    const calcItemTotal = (carts: any) => {
        let sum = 0;
        carts.forEach((item: any) => {
            sum += Number(item.totalItemPrice);
        });
        return sum;
    };

    return (
        <>

            <div className="bucket-conainet-sticky">
                <div className='basket-items'>
                    <div className='item-add'>
                        {cartQty > 0 ?
                            <h3>{cartQty} {cartQty == 1 ? t("ITEMS") : t("ITEM")} {t("ADDED")}</h3>
                            :
                            <h3>{t("ORDER_DETAILS")}</h3>}
                        <div className='kfc-box-theme'>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className='add-to-basket'>
                      
                        <BucketCartItems />
                    </div>
                </div>
               
            </div>

           
        </>
    )
}
